<template>
    <a-modal title="更多资料"
             :width="1200"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="onSubmit"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <table style="width:80%;height: 380px;" >

        </table>
    </a-modal>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import qs from 'qs'
    import 'vue-area-linkage/dist/index.css'
    import {pca, pcaa} from 'area-data'

    export default {
        created() {
            this.userName = this.$store.getters.nickname
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                form: this.$form.createForm(this),
                id: this.$route.query.id,
                pca: pca,
                pcaa: pcaa,
                modalLoading: false,
                params: {},
                loading: false,
                supplier: '',
                city: '',
                province: '',
                district: '',
                // selected:[pcaa[86]['110000'],pcaa['110000']['110100'],pcaa['110100']['110101']]
                selected: []
            }
        },
        methods: {
            initInfo(id) {
                // let that = this
                // this.$http.get('/api/v1/supplier/account/get_supplier_info.json?id=' + id).then(function (res) {
                //     that.supplier = res.result.supplier
                //     that.selected = []
                //     if (that.supplier.province) {
                //         that.selected.push(that.pcaa[86][that.supplier.province])
                //     }
                //     if (that.supplier.province && that.supplier.city) {
                //         that.selected.push(that.pcaa[that.supplier.province][that.supplier.city])
                //     }
                //     if (that.supplier.province && that.supplier.city && that.supplier.district) {
                //         // pcaa['110100']['110101']
                //         that.selected.push(that.pcaa[that.supplier.city][that.supplier.district])
                //     }
                // })
            },
            onSubmit() {

            },
        }
    };
</script>
<style lang="less" scoped>
    .ant-input {
        width: 300px;
    }

    .fx-form th {
        width: 130px;
    }
    /*table {*/
    /*    height: 400px;*/
    /*}*/
</style>
